export default function ($http) {
    return function () {
        return $http.get('api/franchise/')
            .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/franchises.js